<template>
  <div class="homeShowBox" v-if="pageList.length > 0">
    <div class="content-box">
      <div class="content-title">
        <div class="title-left">
          {{ lan ? showData.advertEnName : showData.advertCnName }}
        </div>
        <div class="title-right" @click="toAll">
          {{ lan ? "MORE" : "查看全部" }}
          <img
            class="youjiantou"
            src="../../assets/youjiantou_grey@2x.png"
            alt=""
          />
        </div>
      </div>
      <div class="sub-title-top">
        {{ lan ? showData.advertEnDesc : showData.advertCnDesc }}
      </div>
      <div class="content-img-box">
        <div
          class="img-show"
          v-for="item in pageList"
          :key="item.id"
          @click="toDetails(item)"
        >
          <img class="store-img-qr" :src="item.showSrc" alt="" />
          <div class="sub-title" v-if="showType != 1">
            <div class="sub-title-dec-info">
              {{ lan ? item.exhibitEnTitle : item.exhibitCnTitle }}
            </div>
            <!-- <div class="home-time-dec">
              <img src="../../assets/home-time.png" alt="" />
              <div v-if="item.exhibitType == 0">
                {{ item.startDate }}-{{ item.endDate }}
              </div>
              <div v-else>常展</div>
            </div> -->
          </div>
          <div class="sub-title" v-else>
            {{ lan ? item.activityEnTitle : item.activityCnTitle }}
          </div>
          <div class="home-show-info" v-if="showType != 1">
            {{ lan ? item.exhibitEnSubTitle : item.exhibitCnSubTitle }}
          </div>
          <div class="home-show-info" v-else>
            {{ lan ? item.activityEnSubTitle : item.activityCnSubTitle }}
          </div>
          <div class="home-show-dec" v-if="showType != 1">
            {{ lan ? item.exhibitPlaceEn : item.exhibitPlaceCn }}
          </div>
          <div class="home-show-dec" v-else-if="item.startDate && item.endDate">
            {{ item.startDate }}-{{ item.endDate }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="showLine" class="grey-line"></div>
  </div>
</template>

<script>
export default {
  props: {
    showData: {
      type: Object,
      default: () => ({}),
    },
    showLine: {
      type: Boolean,
      default: true,
    },
    showType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lan: this.$store.state.isEn,
      pageList: [],
      id: "",
      nowScrollToTop: 0,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
    showData: {
      handler(newValue, oldValue) {
        this.id = newValue.advertCnDetail;
        this.init(this.id);
      },
      deep: true, // 如果需要监听对象内部值的变化，需要设置 deep 为 true
    },
  },
  methods: {
    init(id) {
      // 添加参数有效性检查
      if (!this.showData || !this.id) return;
      
      // 优化API路径和参数设置逻辑
      const api = this.showType == 1 ? "/activity/list" : "/exhIbit/list";
      const data = {
        current: 1,
        pageSize: 10,
        id: id || ""
      };
      
      this.$api.get(api, { ...data }, (r) => {
        const { data, code } = r || {};
        if (code === 0 && data && Array.isArray(data)) {
          // 优化图片处理逻辑
          if (data.length > 0 && this.showData.imgList) {
            data.forEach((el, index) => {
              // 添加边界检查，防止imgList越界
              if (this.showData.imgList[index]) {
                el.showSrc = this.showData.imgList[index].src;
              }
            });
          }
          // 确保只显示前两个项目
          this.pageList = data.slice(0, 2);
        } else {
          console.error("Failed to fetch data:", r);
          this.pageList = [];
        }
      });
    },
    toAll() {
      // 优化路由跳转逻辑，减少重复代码
      const routeInfo = this.showType ? 
        { path: "/activityList/activityList", query: { columnId: 3 } } :
        { path: "/exhibition/exhibitionPage", query: { columnId: 2 } };
        
      this.$router.push(routeInfo).catch(err => {
        // 添加路由错误处理，避免NavigationDuplicated错误
        if (err.name !== "NavigationDuplicated") {
          console.error("Routing error:", err);
        }
      });
    },
    toDetails(item) {
      // 优化链接处理逻辑
      if (item.link) {
        window.open(item.link, '_blank');
      } else {
        // 优化路由跳转逻辑，减少重复代码
        const routeInfo = this.showType ? 
          { 
            path: "/activityList/activityListInfo",
            query: {
              columnId: 3,
              activityType: item.id,
            }
          } :
          {
            path: "/exhibition/exhibitionInfo",
            query: {
              columnId: 2,
              id: item.id,
            }
          };
          
        this.$router.push(routeInfo).catch(err => {
          // 添加路由错误处理，避免NavigationDuplicated错误
          if (err.name !== "NavigationDuplicated") {
            console.error("Routing error:", err);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.homeShowBox {
  width: 100%;
  position: relative;
}
.content-box {
  margin: 25px auto;
  background-color: #fff;
}
.content-title {
   width: 90%;
   margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 32px;
  color: #ca9d76;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
}
.title-right {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #98989f;
  text-align: left;
  font-weight: Regular;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.youjiantou {
  width: 10px;
  height: 12px;
  margin: 0% 0 0 5px;
}
.sub-title {
  position: relative;
  font-family: SourceHanSansCN-Bold;
  font-size: 26px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.sub-title-dec-info{
  max-width: 95%;
}
.grey-line {
  background: #f2f2f2;
  height: 10px;
  width: 100%;
}
.content-img-box {
  width: 100%;
}
.img-show {
  position: relative;
  width: 90%;
  cursor: pointer;
  margin: 0px auto 25px;
}

.store-img-qr {
  width: 100%;
  max-height: 440px;
  cursor: pointer;
}
.home-show-info {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
  margin: 5px 0;
}
.home-show-dec {
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
}
.sub-title-top {
   width: 90%;
   margin: 10px auto;
  font-size: 22px;
  color: #000000;
  text-align: left;
}
.home-time-dec {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #98989f;
  letter-spacing: 0;
  text-align: right;
  font-weight: 300;
}
.home-time-dec img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
@media (max-width: 768px) {
  .title-left {
    font-size: 28px;
  }
  .title-right {
    font-size: 14px;
  }

  .sub-title {
    font-size: 18px;
  }

  .home-show-info {
    font-size: 14px;
  }
  .home-show-dec {
    font-size: 12px;
  }
  .sub-title-top {
    font-size: 18px;
  }
  .home-time-dec {
    right: 5px;
    top: 0;
    font-size: 12px;
  }
  .home-time-dec img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
}
@media (max-width: 420px) {
  .title-left {
    font-size: 26px;
  }
  .sub-title {
    font-size: 22px;
  }
  .sub-title-top {
    font-size: 18px;
  }
  .home-show-info {
    font-size: 14px;
  }
  .home-time-dec {
    right: 5px;
    top: 0;
    font-size: 12px;
  }
  .home-show-dec {
    font-size: 10px;
  }
}
</style>